import { render, staticRenderFns } from "./wenben.vue?vue&type=template&id=06d5c291&scoped=true"
import script from "./wenben.vue?vue&type=script&lang=ts"
export * from "./wenben.vue?vue&type=script&lang=ts"
import style0 from "./wenben.vue?vue&type=style&index=0&id=06d5c291&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d5c291",
  null
  
)

export default component.exports